import { Image } from "react-bootstrap";
import Col from "react-bootstrap/esm/Col";
import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/esm/Row";
import "./ThankYouPage.css"
import FullLogo from '../../../assets/full_logo.png'
import PrimaryButton from "shared/components/PrimaryButton";
import { Link } from "react-router-dom";
import React from "react";
import { connect, ConnectedProps } from "react-redux";
import loanApplicationUtility from "utilities/LoanApplicationUtility";

const mapState = (route: any) => {
  return {
    
  };
};

const connector = connect(mapState);
type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = PropsFromRedux;

class ThankYouPage extends React.Component<Props> {
  loanId = 0;

  constructor(props: any) {
    super(props);
    
    this.loanId = +props.match.params.loanId;
    
    this.state = {

    }
  }
  render() {
    return (
      <Container className="d-flex align-items-center fill-screen" fluid>
        <Row className="justify-content-md-center">
          <Col className="align-self-center">
            <Image src={FullLogo} fluid />
          </Col>
          <Col className="align-self-center">
            <h1>Thank You!</h1>
            <p>
              {`Your loan application has been submitted successfully, with the ID: ${loanApplicationUtility.BuildDisplayId(this.loanId)}! Please check your email to verify your email address, update your password, and login.`}
            </p>
            <Link to={'/'}>
              <PrimaryButton buttonText={'Home'} onClick={() => { }}></PrimaryButton>
            </Link>
          </Col>
        </Row>
      </Container>
    );
  }
}


export default ThankYouPage;